module.exports = __webpack_public_path__ + "static/media/PrescreeningContact.4cae7f58.png";